angular.module('signalview.chartTemplates').run([
    'chartTemplates',
    'Chart',
    'plotUtils',
    'blockService',
    function (chartTemplates, Chart, plotUtils, blockService) {
        function createChart(filters) {
            function addPlot(metric, color) {
                const plot = chart
                    .plot()
                    .metric(metric)
                    .name(metric + ' in bytes')
                    .visible(false)
                    .propertyFilters(filters)
                    .addManipulation(blockService.sum.asAggregation([{ value: 'sf_metric' }]));

                const plotLetter = plotUtils.getLetterFromUniqueKey(plot.uniqueKey());
                chart
                    .plot()
                    .macro(plotLetter + ' / 1000000000')
                    .color(color)
                    .name(metric);
            }

            const chart = Chart.create()
                .name('Total Memory')
                .type('area')
                .stacked(true)
                .yAxis(0, { label: 'Gigabytes', min: 0 });

            addPlot('memory.free', '#05ce00');
            addPlot('memory.used', '#e9008a');
            addPlot('memory.buffered', '#00b9ff');
            addPlot('memory.cached', '#e5b312');

            return chart;
        }

        chartTemplates.register('collectdHostsTotalMemory', createChart);
    },
]);
